import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class ExternalLinkWarningModal extends Modal {
  className() {
    return 'ExternalLinkWarningModal Modal--small';
  }
  title() {
    return 'Переход на внешний сайт';
  }
  content() {
    const target = new URL(this.attrs.url);
    const punycode = target.hostname.includes('xn--');
    return m('.Modal-body', [m('.dc-external-warning__icon', '↗'), m('p', 'Вы покидаете DevConnect. Перед переходом проверьте домен — мошенники часто используют похожие адреса.'), m('.dc-external-warning__domain', target.hostname), punycode ? m('.Alert.Alert--error', 'Адрес содержит punycode. Особенно внимательно проверьте написание домена.') : null, m('.dc-external-warning__actions', [m(Button, {
      className: 'Button Button--primary',
      onclick: () => {
        window.open(target.href, '_blank', 'noopener,noreferrer');
        this.hide();
      }
    }, 'Продолжить'), m(Button, {
      className: 'Button',
      onclick: () => this.hide()
    }, 'Отмена')])]);
  }
}
flarum.reg.add('devconnect-link-cards', 'forum/components/ExternalLinkWarningModal', ExternalLinkWarningModal);
flarum.reg.add('devconnect-link-cards', 'forum/components/ExternalLinkWarningModal', ExternalLinkWarningModal);